<script>
import axios from "axios";
export default {
  methods: {
    deleteItem(item, confirmMessage){
      global.openConfirmModal({
        title: confirmMessage || this.$t('confirm:delete item'),
        ok: {
          title: this.$t('applications: delete list item'),
          icon: 'ph ph-trash',
          callback: () => {

            this.isLoading = true
            axios.postForm(`${this.basePath()}lists/delete_list_item`, {
              uuid: item.uuid,
              list: this.list,
              owner: this.owner,
              _token: this.token()
            }).then( response => {
              if(response === 'ok'){
                const index = this.items.indexOf(item);
                if (index > -1) {
                  this.items.splice(index, 1);
                  $(this.$root.$el.parentElement).trigger('change');
                }
              }
            }).catch( error => {
              // handle error
            }).finally( () => {
              this.updateList()
            })


          }
        }
      })
    },
  }
}
</script>

<template>

</template>